<template>
  <div>
    <a-form :form="form" class="card-header p-5" @submit="addActivity">
      <div class="row">
        <div class="col-md-6">
          <a-form-item>
            <a-select
              v-decorator="[
                'activity',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('paiement.activiteRequis'),
                    },
                  ],
                },
              ]"
              show-search
              :placeholder="
                loadingActivities
                  ? $t('all.loadingText')
                  : $t('paiement.listeActivites')
              "
              :disabled="loadingActivities"
              style="width: 100%"
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="(v) => selectActivity(v)"
            >
              <a-select-option
                v-for="activtiy in activities"
                :key="activtiy._id"
                :value="activtiy._id"
              >
                {{ activtiy.designation }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-md-12">
          <StudentSelectorFields
            v-model="selectionMode"
            :student-list="studentList"
            :classes="classes"
            :students-data="studentsData"
            :level-select-data="levelSelectData"
            :loading-students="loadingStudents"
            :loading-classes="loadingClasses"
            @level-students-change="selectedLevelStudents = $event"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <a-form-item>
            <a-date-picker
              :allowClear="false"
              :disabled-date="disabledDate"
              @change="
                (start) => {
                  currentFeesRange.start = start;
                  setIncludedFees();
                }
              "
              v-decorator="[
                'start',
                {
                  defaultValue: this.activitySelected.start,
                  rules: [
                    {
                      required: true,
                      message: $t('paiement.dateDebutRequis'),
                    },
                  ],
                },
              ]"
              :format="dateFormat"
              style="width: 100%"
            />
          </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item>
            <a-date-picker
              @change="
                (end) => {
                  currentFeesRange.end = end;
                  setIncludedFees();
                }
              "
              :disabled-date="disabledEndDate"
              v-decorator="[
                'end',
                {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :format="dateFormat"
              style="width: 100%"
            />
          </a-form-item>
        </div>
      </div>
      <!-- Payment mode selection - hidden for daily activities -->
      <MonthlyFeesSection
        v-if="activityInfos._id && !activityInfos.daily"
        :activity="activityInfos"
        :mode="modePaiement"
        :included-fees="includedFees"
        @change-mode="changeModeP"
        @toggle-fee="changeIncludedFees"
      />

      <!-- Daily activity fees display and calendar selection -->
      <DailyFeesSection
        v-if="activityInfos._id && activityInfos.daily"
        :activity="activityInfos"
        :selected-dates="selectedDailyDates"
        :activity-start="activitySelected.start"
        :activity-end="activitySelected.end"
        @add-date="addSelectedDate"
        @remove-date="removeSelectedDate"
        @clear-all-dates="clearAllDates"
      />

      <div class="row">
        <div class="col-md-12 mt-5">
          <a-button
            type="primary"
            style="width: 100%"
            htmlType="submit"
            :loading="loadingClasse"
            :disabled="loadingClasse"
            icon="tags"
            :ghost="false"
          >
            {{ $t("action.ajouter") }}
          </a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState } from "vuex";
import { getLevels } from "@/config/LevelConstants";
import store from "store";
import { dateRange, dailyDateRange } from "@/utilities/settings";
import StudentSelectorFields from "./components/StudentSelectorFields.vue";
import MonthlyFeesSection from "./components/MonthlyFeesSection.vue";
import DailyFeesSection from "./components/DailyFeesSection.vue";

const actvitiyPaymentsFormater = (activityFees, studentId, studentList) => {
  const getClassRoom = (studentId, studentList) => {
    try {
      return studentList.filter((s) => s._id == studentId)[0].classRoomName;
    } catch (error) {
      return " ";
    }
  };
  let status = "impayed";
  if (activityFees.inscription) {
    if (!activityFees.activity.once && activityFees.months) {
      status = "payed";
      for (const [key, value] of Object.entries(activityFees.months)) {
        if (!value) {
          status = "impayed";
          break;
        }
      }
    }
  }
  return {
    status,
    inscription: activityFees.inscription,
    months: activityFees.months,
    _id: activityFees._id,
    fullName:
      activityFees.student.firstName + " " + activityFees.student.middleName + " " + activityFees.student.lastName,
    activity: activityFees.activity.designation,
    activityDetails: activityFees.activity,
    class: getClassRoom(studentId, studentList),
  };
};

const monthly = (start, end) => {
  let monthObj = Object();
  dateRange(start, end).forEach((date) => (monthObj[date] = false));
  return monthObj;
};
export default {
  components: {
    StudentSelectorFields,
    MonthlyFeesSection,
    DailyFeesSection,
  },
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
  },

  async created() {
    this.schoolType = this.activeBuilding.type;

    this.form = this.$form.createForm(this, { name: "addActivityForm" });
    apiClient
      .post("/activities/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            designation: 1,
            start: 1,
            end: 1,
            inscription: 1,
            monthly: 1,
            once: 1,
            tranches: 1,
            daily: 1,
          },
        },
      })
      .then((res) => (this.activities = res.data))
      .catch((e) => this.$message.error(this.$t("error.aucActivite")))
      .finally(() => {
        this.loadingActivities = false;
      });
    apiClient
      .post("/students/filter", {
        query: {
          status: "active",
        },
        aggregation: [
          {
            $set: {
              classRoom: {
                $convert: {
                  input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                  to: "objectId",
                  onError: null,
                  onNull: null,
                },
              },
            },
          },
          {
            $set: {
              classRoomName: "$classRoom",
            },
          },
          {
            $lookup: {
              from: "classrooms",
              localField: "classRoom",
              foreignField: "_id",
              as: "classRoomName",
            },
          },
          {
            $project: {
              _id: 1,
              classRoom: 1,
              firstName: 1,
              middleName: 1,
              lastName: 1,
              classRoomName: { $arrayElemAt: ["$classRoomName.name", 0] },
            },
          },
        ],
      })
      .then((res) => {
        const { data } = res;
        this.studentList = data;
        this.studentsData = _.mapValues(_.groupBy(data, "classRoom"), (clist) =>
          clist.map((elem) => _.omit(elem, "classRoom"))
        );
      })
      .catch((e) => this.$message.error(this.$t("error.aucEleve")))
      .finally(() => {
        this.loadingStudents = false;
      });
    await this.getActivitiesPayments();
    await apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
      })
      .then((res) => {
        this.classes = res.data;
      })
      .catch((e) => this.$message.error(this.$t("error.aucClasse")))
      .finally(() => {
        this.loadingClasses = false;
      });
    await this.fetchActivityPayments();
  },

  data() {
    return {
      selectionMode: "students",
      currentFeesRange: {},
      includedFees: {},
      loadingClasse: false,
      dateFormat: "DD/MM/YYYY",
      studentsData: {},
      studentList: [],
      classList: [],
      classes: [],
      activities: [],
      actvitiyFees: [],
      actvitiyPayments: [],
      activitySelected: {
        start: moment(Date.now()),
        end: null,
      },
      activityInfos: {},
      modePaiement: "M",
      selectedDailyDates: [],
      selectedLevelStudents: [],
      schoolType: "",
      loadingStudents: true,
      loadingActivities: true,
      loadingClasses: true,
    };
  },

  watch: {
    selectionMode() {
      this.form.resetFields(["students", "classes", "levels"]);
    },
  },

  methods: {
    changeIncludedFees(key, e) {
      this.includedFees[key] = e;
      this.$forceUpdate(); // Force re-render
    },
    changeModeP(v) {
      // Prevent changing payment mode for daily activities
      if (this.activityInfos.daily) {
        return;
      }
      this.modePaiement = v;
      this.setIncludedFees();
    },
    moment,
    disabledDate(current) {
      if (!this.activitySelected.end) {
        const schoolarYears = this.settings.schoolarYears;
        const activeSchoolarYear = store.get("app.settings.activeSchoolarYear");
        const schoolarYear = schoolarYears.filter(
          (sc) => sc._id == activeSchoolarYear
        )[0];
        this.activitySelected.end = moment(schoolarYear.end);
      }
      if (!this.activitySelected.start) {
        const schoolarYears = this.settings.schoolarYears;
        const activeSchoolarYear = store.get("app.settings.activeSchoolarYear");
        const schoolarYear = schoolarYears.filter(
          (sc) => sc._id == activeSchoolarYear
        )[0];
        this.activitySelected.start = moment(schoolarYear.start);
      }
      const { start, end } = this.activitySelected;
      return (current && current.isAfter(end)) || current.isBefore(start);
      //return current && current < moment().endOf("day");
    },
    disabledEndDate(current) {
      if (!this.activitySelected.end) {
        const schoolarYears = this.settings.schoolarYears;
        const activeSchoolarYear = store.get("app.settings.activeSchoolarYear");
        const schoolarYear = schoolarYears.filter(
          (sc) => sc._id == activeSchoolarYear
        )[0];
        this.activitySelected.end = moment(schoolarYear.end);
      }
      if (!this.activitySelected.start) {
        const schoolarYears = this.settings.schoolarYears;
        const activeSchoolarYear = store.get("app.settings.activeSchoolarYear");
        const schoolarYear = schoolarYears.filter(
          (sc) => sc._id == activeSchoolarYear
        )[0];
        this.activitySelected.start = moment(schoolarYear.start);
      }
      let { start, end } = this.activitySelected;
      if (this.form.getFieldValue("start"))
        start = this.form.getFieldValue("start");
      return (current && current.isAfter(end)) || current.isBefore(start);
      //return current && current < moment().endOf("day");
    },
    getClassName(classId) {
      const student = this.studentList.find((s) => s.classRoom === classId);
      return student ? student.classRoomName : "";
    },
    selectActivity(val) {
      const activity = [...this.activities].filter((ac) => ac._id == val);
      const { start, end } = activity[0];
      this.activityInfos = activity[0];

      // Reset selected daily dates when changing activity
      this.selectedDailyDates = [];

      // Set modePaiement to 'M' for daily activities
      if (this.activityInfos.daily) {
        this.modePaiement = 'M';
      }

      this.activitySelected.start = moment(start);
      this.activitySelected.end = moment(end);
      this.form.setFieldsValue({
        start: this.activitySelected.start,
        end: this.activitySelected.end,
      });
      this.setIncludedFees();
    },
    validateMonths(activityFees, range) {
      let { start, end } = range;
      let result = true;
      if (!end) end = activityFees.activity.end;
      const newMonthly = monthly(start, end);
      const existMonthly = activityFees.months;
      try {
        if (
          Object.keys(existMonthly).forEach((value) => {
            if (Object.keys(newMonthly).includes(value)) result = false;
          })
        )
          result = false;
      } catch {
        result = false;
      }
      return result;
    },

    validateStudentActivity(student, activity, start, end) {
      const existingActivity = this.activityFees.find(
        (activityPayment) =>
          activityPayment.student === student &&
          activityPayment.activityDetails._id === activity &&
          !this.validateMonths(activityPayment, { start, end })
      );
      return !existingActivity;
    },

    async getStudentsWithoutActivity(studentIds, activityId, start, end) {
      const eligibleStudents = [];
      const ineligibleStudents = [];

      for (const studentId of studentIds) {
        const student = this.studentList.find((s) => s._id === studentId);
        const isEligible = this.validateStudentActivity(
          studentId,
          activityId,
          start,
          end
        );

        if (isEligible) {
          eligibleStudents.push(studentId);
        } else {
          ineligibleStudents.push({
            id: studentId,
            name: student
              ? `${student.firstName} ${student.middleName ? student.middleName + " " : ""} ${student.lastName}`
              : studentId,
          });
        }
      }

      return { eligibleStudents, ineligibleStudents };
    },

    async fetchActivityPayments() {
      try {
        const response = await apiClient.get(
          "/payment/etatImpaye/activity/all"
        );
        this.actvitiyPayments = response.data
          .filter((p) => p && p.studentId && p._id)
          .map((p) => ({
            id: p._id,
            studentId: p.studentId,
            classroom: p.classroom,
            student: p.student,

            name: p.name,
          }));
      } catch (error) {
        this.$message.error(this.$t("error.fetchingData"));
        this.actvitiyPayments = [];
      }
    },

    validateStudentActivity(studentId, activityId, start, end) {
      if (!studentId || !activityId) {

        return false;
      }

      const selectedActivity = this.activities.find(
        (a) => a._id === activityId
      );
      if (!selectedActivity) return true;

      const existingActivity = this.actvitiyPayments.find(
        (payment) =>
          payment.studentId === studentId &&
          payment.name.toLowerCase() ===
            selectedActivity.designation.toLowerCase()
      );

      return !existingActivity;
    },

    async getStudentsWithoutActivity(studentIds, activityId, start, end) {
      const eligibleStudents = [];
      const ineligibleStudents = [];

      if (!Array.isArray(studentIds)) {
        return { eligibleStudents: [], ineligibleStudents: [] };
      }

      for (const studentId of studentIds) {
        if (!studentId) continue;

        const isEligible = this.validateStudentActivity(
          studentId,
          activityId,
          start,
          end
        );
        const existingPayment = this.actvitiyPayments.find(
          (p) => p.studentId === studentId
        );

        if (isEligible) {
          eligibleStudents.push(studentId);
        } else {
          ineligibleStudents.push({
            id: studentId,
            name: existingPayment
              ? existingPayment.student
              : this.studentList.find((s) => s._id === studentId)?.firstName +
                  " " +
                  (this.studentList.find((s) => s._id === studentId)?.middleName ?
                   this.studentList.find((s) => s._id === studentId)?.middleName + " " : "") +
                  " " +
                  this.studentList.find((s) => s._id === studentId)?.lastName ||
                studentId,
          });
        }
      }

      return { eligibleStudents, ineligibleStudents };
    },

    addActivity(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // Validate daily activities
          if (this.activityInfos.daily && this.selectedDailyDates.length === 0) {
            this.$message.warning(this.$t('etablissement.selectionnerAuMoinsUnJour'));
            return;
          }

          this.loadingClasse = true;

          try {
            let studentsToProcess = [];
            if (this.selectionMode === "students") {
              studentsToProcess = values.students;
            } else if (this.selectionMode === "classes") {
              values.classes.forEach((classId) => {
                const classStudents = this.studentsData[classId] || [];
                studentsToProcess.push(...classStudents.map((s) => s._id));
              });
            } else if (this.selectionMode === "levels") {
              studentsToProcess = this.selectedLevelStudents || [];
            }

            if (studentsToProcess.length === 0) {
              this.$message.warning(this.$t("error.aucEleve"));
              return;
            }

            studentsToProcess = [...new Set(studentsToProcess)];

            const { eligibleStudents, ineligibleStudents } =
              await this.getStudentsWithoutActivity(
                studentsToProcess,
                values.activity,
                values.start,
                values.end || this.activityInfos.end
              );

            if (ineligibleStudents.length > 0) {
              const ineligibleNames = ineligibleStudents
                .map((student) => student.name)
                .join(", ");

              this.$message.warning(
                `${this.$t(
                  "error.eleveDejaInscritPourMois"
                )} : ${ineligibleNames}`
              );

              if (eligibleStudents.length === 0) {
                return;
              }
            }

            const filteredRepReduction = Object.keys(this.includedFees)
              .filter((key) => this.includedFees[key] === true)
              .reduce((obj, key) => {
                obj[key] = false;
                return obj;
              }, {});

            const data = {
              start: values.start,
              end: values.end || this.activityInfos.end || undefined,
              students: eligibleStudents,
              activity: values.activity,
              inscription: values.inscription,
              typeAS: "A",
              mode: this.modePaiement,
              repReduction: Object.keys(filteredRepReduction).reduce(
                (obj, key) => {
                  obj[key] = 0;
                  return obj;
                },
                { inscription: 0 }
              ),
            };

            if (this.modePaiement == "M") {
              data.months = filteredRepReduction;
            } else {
              data.tranches = filteredRepReduction;
            }

            await apiClient.put(
              "/payment/registerStudents",
              values.end ? { ...data, end: values.end } : data
            );

            await this.fetchActivityPayments();

            this.$message.success(this.$t("success.inscriAjout"));
            if (ineligibleStudents.length > 0) {
              this.$message.info(
                `${eligibleStudents.length} ${this.$t("success.eleveInscrit")}`
              );
            }
            this.$emit("updateActivityInscription");
            this.resetForm();
          } catch (error) {
            console.error(error);
            this.$message.error(this.$t("error.inscriEchoue"));
          } finally {
            this.loadingClasse = false;
          }
        }
      });
    },

    resetForm() {
      this.selectionMode = "students";
      this.currentFeesRange = {};
      this.includedFees = {};
      this.activitySelected = {
        start: moment(Date.now()),
        end: null,
      };
      this.activityInfos = {};
      this.modePaiement = "M";
      this.selectedDailyDates = [];
      this.selectedLevelStudents = [];
      if (this.form) {
        this.form.resetFields();
      }
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getActivitiesPayments() {
      this.tableLeading = true;
      await apiClient
        .post("/payment/filter", {
          query: {
            status: "active",
            typeAS: "A",
          },
        })
        .then(
          (res) =>
            (this.activityFees = res.data.map((elem) =>
              actvitiyPaymentsFormater(elem, elem.student._id, this.studentList)
            ))
        )
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.aucInscri"));
        })
        .finally(() => {
          this.tableLeading = false;
        });
    },
    setIncludedFees() {
      const activeSchoolarYear = this.settings.activeSchoolarYear;
      const schoolarYears = this.settings.schoolarYears;
      let start = this.currentFeesRange.start || this.activityInfos.start;
      let end = this.currentFeesRange.end || this.activityInfos.end;
      schoolarYears.forEach((elem) => {
        if (elem._id == activeSchoolarYear) {
          if (!end) end = elem.end;
          if (!start) start = elem.start;
        }
      });

      this.includedFees = {};

      // For daily activities, use daily date range and let user select specific days
      if (this.activityInfos.daily) {
        this.modePaiement = 'M';
        // Don't auto-populate includedFees for daily activities
        // User will select specific days via calendar
        return;
      } else {
        // For non-daily activities, use monthly range logic
        const range = this.dateRange(
          moment(start).format("YYYY-MM-DD"),
          moment(end).format("YYYY-MM-DD")
        );

        if (this.activityInfos.monthly && this.modePaiement == "M") {
          range.forEach((month) => {
            this.includedFees[month] = true;
          });
        }
        if (this.activityInfos.tranches && this.modePaiement == "T") {
          this.activityInfos.tranches.forEach((tranche) => {
            this.includedFees[tranche.trancheNumber] = true;
          });
        }
      }
    },

    addSelectedDate(date) {
      if (this.activityInfos.daily && !this.selectedDailyDates.includes(date)) {
        this.selectedDailyDates.push(date);
        this.updateDailyIncludedFees();
      }
    },
    clearAllDates() {
      this.selectedDailyDates = [];
      this.updateDailyIncludedFees();
    },
    removeSelectedDate(date) {
      const index = this.selectedDailyDates.indexOf(date);
      if (index > -1) {
        this.selectedDailyDates.splice(index, 1);
        this.updateDailyIncludedFees();
      }
    },
    updateDailyIncludedFees() {
      if (this.activityInfos.daily) {
        this.includedFees = {};
        this.selectedDailyDates.forEach(date => {
          this.includedFees[date] = true;
        });
      }
    },
    dateRange,
    dailyDateRange,
  },
};
</script>
<style scoped>
.custom-tag .ant-tag {
  padding: 4px 7px 4px 7px;
  font-size: 13px;
  margin-left: 3px;
}

.custom-tag .ant-tag:hover {
  cursor: pointer;
}
</style>
